import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		header: {
			textTransform: "none" as const,
			paddingTop: 20,
			height: 60,
		}
	} satisfies Record<string, CSSObject>;
};
